import { Badge, Table } from 'react-bootstrap';

import type { WorkspaceRunStatus } from '@/services/announcementsService';

const BADGE: Record<WorkspaceRunStatus['state'], { bg: string; label: string }> = {
  queued: { bg: 'secondary', label: 'Waiting' },
  running: { bg: 'info', label: 'Working' },
  success: { bg: 'success', label: 'Done' },
  waiting: { bg: 'warning', label: 'Waiting for an update' },
  failed: { bg: 'danger', label: 'Failed' },
};

interface WorkspaceRunTableProps {
  statuses: Record<string, WorkspaceRunStatus>;
}

/** One row per workspace: where each write is up to, and why one failed. */
export function WorkspaceRunTable({ statuses }: WorkspaceRunTableProps) {
  const names = Object.keys(statuses).sort();
  return (
    <div className="announcement-run-table">
      <Table hover className="mb-0">
        <thead>
          <tr>
            <th>Workspace</th>
            <th className="announcement-run-table__state">State</th>
            <th>What happened</th>
          </tr>
        </thead>
        <tbody>
          {names.map((name) => {
            const status = statuses[name];
            const badge = BADGE[status.state];
            return (
              <tr key={name}>
                <td className="mono">{name}</td>
                <td>
                  <Badge bg={badge.bg}>{badge.label}</Badge>
                </td>
                <td className={status.state === 'failed' ? 'announcement-run-table__reason--bad' : undefined}>
                  {status.message}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}
